<template>
  <div class="mini-game-manager">
    <el-tabs v-model="activeTab" type="border-card">
      <el-tab-pane label="小游戏管理" name="games">
        <MiniGameList />
      </el-tab-pane>
      <el-tab-pane label="资源配置" name="resources">
        <MiniGameResources />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MiniGameList from "./MiniGameList.vue";
import MiniGameResources from "./MiniGameResources.vue";

export default {
  name: "MiniGames",
  components: {
    MiniGameList,
    MiniGameResources
  },
  data() {
    return {
      activeTab: "games"
    };
  }
};
</script>

<style scoped>
.mini-game-manager {
  padding: 20px;
}
</style>
